<template>
    <div class="modal-backdrop" @click="closeIfClickedOutside">
      <div class="modal">
        <header class="modal-header">
          <slot name="header">{{$t("Download.modalWindow")}}</slot>
          <button type="button" class="btn-close" @click="close">x</button>
        </header>
        
        <section class="modal-body">
          {{ console.log(zip_files) }}
          <div class="templateBox" v-for="file in zip_files">
           <div>
              {{ file }}
           </div> 
          </div>
        </section>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ZipModal',
    props: {
      zip_files: Array,
    },
    methods: {
      close() {
        this.$emit('close');
      },
      closeIfClickedOutside(event) {
      // Check if the click event originated from within the modal
        if (!event.target.closest('.modal')) {
          this.close();
        }}
    },
  };
  </script>
  
  <style scoped lang="scss" src="@/assets/css/components/ZipModal.scss" />